import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_private/dashboard/_base/")({
  component: RouteComponent,
  beforeLoad: () => {
    throw redirect({ to: "/dashboard/pedidos" });
  }
});

//TODO - Lembrar de implementar gráficos na home em dashboard
function RouteComponent() {
  // return (
  //   <>
  //     <AppShell.Section maw={800} mx="auto"></AppShell.Section>
  //   </>
  // );

  return null;
}
